module.exports = __webpack_public_path__ + "img/move05.c287f832.jpg";